const Unit = {
    INCH: 'INCHES',
    CM: 'CENTIMETERS'
}

export default Unit;